module.exports = __webpack_public_path__ + "img/Keterbukaan-Value.afb3cebe.png";